import Vue from 'vue'
import store from '@/store'
import {mapGetters, mapActions}    from 'vuex'
import parseTwilioChatsResponse from '@/utils/twilioChatsParse'

function parseChatsResponseSafe (data) {
  if (typeof parseTwilioChatsResponse === 'function') {
    return parseTwilioChatsResponse(data)
  }
  if (Array.isArray(data)) {
    return {
      chats: data,
      pagination: { hasMore: false, offset: 0, returned: data.length, limit: null },
    }
  }
  var chats = data && Array.isArray(data.chats) ? data.chats : []
  return {
    chats: chats,
    pagination: (data && data.pagination) || {
      hasMore: false,
      offset: 0,
      returned: chats.length,
      limit: null,
    },
  }
}

const axios  = require('axios');
var moment   = require('moment');

moment.locale(); 

export default {
	data: () => ({
    // Alertas
    parametros:{
      dialogError: false,
      mensaje: '',
      color: ''
    },

    respuestaAlerta:false,
    loader: true,
    cargar: false,

    etiquetas: [],
    etiquetas2: [],
    etiquetas_inscritos: [],

    tiempos: [
      { idtiempos: 1, text: 'A tiempo'    , color: 'green'},
      { idtiempos: 2, text: 'Por vencer'  , color: 'yellow'},
      { idtiempos: 3, text: 'Vencido'     , color: 'red'},
    ],
    vendedorasTwilio:[]
  }),

	computed: {
	
		...mapGetters('login', ['getdatosUsuarioERPERP','getLogeado', 'getEscuela','getEstatusLlamada','getTareas','getNuevosProspectos']),
    ...mapGetters('twilio',['getConversacionesM','getConversacionesC', 'getConversacionesG','getConversacionesFast','getConversacionesAgente','getConversacionesCRM','getConversacionesCRMFast', 'getConversacionesO']),

    etiquetaChatAbierta () {
      if (!this.chat) return null
      const id = Number(this.chat.idetiquetas)
      if (!id) return null
      const lista = (this.etiquetas2 && this.etiquetas2.length) ? this.etiquetas2 : (this.etiquetas || [])
      for (let i = 0; i < lista.length; i++) {
        if (Number(lista[i].idetiquetas) === id) return lista[i]
      }
      if (id === 7) return { idetiquetas: 7, text: 'SPAM', etiqueta: 'SPAM', color: '#000000' }
      return {
        idetiquetas: id,
        text: 'Etiqueta ' + id,
        etiqueta: 'Etiqueta ' + id,
        color: this.chat.color || 'grey',
      }
    },
	
	},

	created () {
    if (!this.skipMixinWhatsAppInit) {
      if (this.unificar) {
        this.initializeAllCities()
      } else {
        this.initialize()
      }
    }
    this.getEtiquetas()
    this.getEtiquetasInscritos()
    this.getAccesosCRM()
  },

  methods: {

    // Activa un filtro de menú; si se vuelve a elegir el mismo, lo desactiva
    toggleFiltro(campo, item, clave, valorApagado) {
      if (valorApagado === undefined) valorApagado = null
      const actual = this[campo]
      const mismo = actual && item && (
        clave ? actual[clave] === item[clave] : actual === item
      )
      this[campo] = mismo ? valorApagado : item
    },

    // Si el filtro ya está activo, el FAB lo apaga; si no, abre el menú
    listenersFiltroMenu(campo, valorApagado, menuOn) {
      const valorOff = valorApagado === undefined ? null : valorApagado
      return {
        ...(menuOn || {}),
        click: (e) => {
          if (this[campo]) {
            this[campo] = valorOff
            return
          }
          if (menuOn && typeof menuOn.click === 'function') menuOn.click(e)
        }
      }
    },

    conteoEtiquetas(lista){
      // Validar que lista sea un array antes de procesarlo
      if (!Array.isArray(lista) || !Array.isArray(this.etiquetas)) {
        return;
      }

      const conteo = {}
      for (let i = 0; i < lista.length; i++) {
        const item = lista[i]
        if (!item || item.idetiquetas === undefined || item.idetiquetas === null || item.idetiquetas === '') continue
        const id = item.idetiquetas
        conteo[id] = (conteo[id] || 0) + 1
      }

      let cambio = false
      const next = this.etiquetas.map(et => {
        const count = conteo[et.idetiquetas] || 0
        if (et.count !== count) cambio = true
        return Object.assign({}, et, { count: count })
      })
      // No reasignar si el conteo no cambió: filterChats llama esto y un array nuevo en cada pase deja la vista sin pintar la etiqueta
      if (cambio) this.etiquetas = next
    },

    conteoTiempos(lista) {
      if (!Array.isArray(lista)) return

      let aTiempo = 0
      let porVencer = 0
      let vencido = 0

      for (const el of lista) {
        if (!el) continue
        const t = Number(el.tiemporestante)
        if (t > 2) aTiempo++
        else if (t > 0 && t <= 2) porVencer++
        else if (t <= 0) vencido++
      }

      this.tiempos = this.tiempos.map(it => ({
        ...it,
        count: it.idtiempos == 1 ? aTiempo : it.idtiempos == 2 ? porVencer : vencido
      }))
    },

    conteoIncompletos(lista) {
      if (!Array.isArray(lista) || !Array.isArray(this.opcionesIncompletos)) return

      let conInteres = 0
      let sinInteres = 0
      let sinIncompletos = 0

      for (const el of lista) {
        if (!el) continue
        if (el.folio) sinIncompletos++
        else if (Number(el.totalMensajes) >= 2) conInteres++
        else sinInteres++
      }

      const labels = {
        con_interes: 'Incompletos con interés',
        sin_interes: 'Incompletos sin interés',
        sin_incompletos: 'Sin incompletos',
      }
      const counts = {
        con_interes: conInteres,
        sin_interes: sinInteres,
        sin_incompletos: sinIncompletos,
      }

      this.opcionesIncompletos = this.opcionesIncompletos.map(op => ({
        ...op,
        count: counts[op.value] || 0,
        text: `${labels[op.value] || op.text} (${counts[op.value] || 0})`,
      }))
    },
    // Obtener todos lso chats de un número
    initialize ( escuela, numTwilio ) {
      this.cargar = true
      this.conversaciones = []
      let numeroTwilio = !this.unificar && this.numeroTwilio ? this.numeroTwilio : numTwilio
      const payload = {
        twilio: numeroTwilio,
        idusuario: this.filtroVendedora ? this.filtroVendedora.iderp : this.getdatosUsuarioERPERP.iderp,
        escuela: escuela ? escuela : this.getEscuela,
      }

      return this.$http.post('twilio.chats', payload ).then(response=>{
        const { chats } = parseChatsResponseSafe(response.data)

        for( const i in chats ){
          chats[i]['sinleer'] = 0
        }


        this.conteoEtiquetas(chats)
        if( this.numeroTwilio == 'whatsapp:+5218187047279' ){
          if( [1,334,568,'1','334','568',32,'32',718,'718'].includes( this.getdatosUsuarioERPERP.iderp ) ){
            this.guardarConversacionesM( chats )
          }else{
            this.guardarConversacionesM( chats.slice(0, 800) )
          }
        }

        if( this.numeroTwilio == 'whatsapp:+5215545703336' ){
          if( [1,334,568,'1','334','568',32,'32',718,'718'].includes( this.getdatosUsuarioERPERP.iderp ) ){
            this.guardarConversacionesC( chats )
          }else{
            this.guardarConversacionesC( chats.slice(0, 800) )
          }
        }

        if( this.numeroTwilio == 'whatsapp:+5213316971156' ){
          if( [1,334,568,'1','334','568',32,'32',718,'718'].includes( this.getdatosUsuarioERPERP.iderp ) ){
            this.guardarConversacionesG( chats )
          }else{
            this.guardarConversacionesG( chats.slice(0, 800) )
          }
        }

        if( this.numeroTwilio == 'whatsapp:+5218123255321' ){
          if( [1,334,568,'1','334','568',32,'32',718,'718'].includes( this.getdatosUsuarioERPERP.iderp ) ){
            this.guardarConversacionesFast( chats )
          }else{
            this.guardarConversacionesFast( chats.slice(0, 800) )
          }
        }

        if( this.numeroTwilio == 'whatsapp:+5215540435043' || this.numeroTwilio == 'whatsapp:+5215534952943' ){
          if( [1,334,568,'1','334','568',32,'32',718,'718'].includes( this.getdatosUsuarioERPERP.iderp ) ){
            this.guardarConversacionesAgente( chats )
          }else{
            this.guardarConversacionesAgente( chats.slice(0, 800) )
          }
        }

        if( this.numeroTwilio == 'whatsapp:+5218124384082' ){
          if( [1,334,568,'1','334','568',32,'32',718,'718'].includes( this.getdatosUsuarioERPERP.iderp ) ){
            this.guardarConversacionesCRM( chats )
          }else{
            this.guardarConversacionesCRM( chats.slice(0, 800) )
          }
        }

        if( this.numeroTwilio == 'whatsapp:+5218124387901' ){
          if( [1,334,568,'1','334','568',32,'32',718,'718'].includes( this.getdatosUsuarioERPERP.iderp ) ){
            this.guardarConversacionesCRMFast( chats )
          }else{
            this.guardarConversacionesCRMFast( chats.slice(0, 800) )
          }
        }

        if( this.numeroTwilio == 'whatsapp:+5215531108468'){
          if( [1,334,568,'1','334','568',32,'32',718,'718'].includes( this.getdatosUsuarioERPERP.iderp ) ){
            this.guardarConversacionesOnline( chats )
          }else{
            this.guardarConversacionesOnline( chats.slice(0, 800) )
          }
        }

      
        this.cargar      = false
      }).catch( error =>{
        console.log( error)
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })


    },

    // Obtener todos lso chats de un número
    getAccesosCRM () {
      this.cargar = true
      return this.$http.get('twilio.acceso.crm/' + this.getdatosUsuarioERPERP.iderp ).then(response=>{
        this.vendedorasTwilio = response.data
        this.cargar      = false

      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    getEtiquetas () {
      this.etiquetas = []
      this.etiquetas2 = []
      this.cargar = true
      return this.$http.get('twilio.etiquetas' ).then(response=>{
        const data = Array.isArray(response.data) ? response.data : []
        const nuevo = {
          idetiquetas: 12,
          text: 'NUEVO',
          color: '#E040FB',
          etiqueta: 'NUEVO',
          detalles: 'Cuándo usar: El prospecto acaba de entrar al sistema y nadie lo ha tocado.'
        }
        this.etiquetas = data.slice()
        this.etiquetas2 = data.slice()
        if (!this.etiquetas.some(e => Number(e.idetiquetas) === 12)) this.etiquetas.unshift(Object.assign({}, nuevo))
        if (!this.etiquetas2.some(e => Number(e.idetiquetas) === 12)) this.etiquetas2.unshift(Object.assign({}, nuevo))
        this.cargar      = false

      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    getEtiquetasInscritos () {
      this.etiquetas_inscritos = []
      this.cargar = true
      return this.$http.get('twilio.etiquetas.inscritos' ).then(response=>{
        this.etiquetas_inscritos = response.data
        this.cargar              = false

      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    crearTemplateSonido( ){

      this.sonido = document.createElement("audio");

      this.sonido.src = require("@/assets/tone.mp3");

      this.sonido.setAttribute("preload", "auto");
      this.sonido.setAttribute("controls", "none");
      this.sonido.style.display = "none"; // <-- oculto

      document.body.appendChild(this.sonido);

    },

    async limpiarRecorder( ){

      if( this.recorder ){

        this.recorder.reset()
        this.recorder.clearRecordedData()

        this.recorder.destroy()

        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        // Detener la transmisión del flujo de audio del micrófono
        stream.getTracks().forEach(track => track.stop());

        // Destruir la instancia del objeto MediaStream
        stream.getTracks().forEach(track => track.enabled = false);
        stream.getTracks().forEach(track => track.readyState == 'ended');

      }
    },

    validayGuardaMensajes( payload = {} ){
      if (!this.chat || !this.chat.usuario) return

      let conversaciones = []
      let destino = null

      if( this.numeroTwilio == 'whatsapp:+5218187047279' ){
        conversaciones = [...(this.getConversacionesM || [])]
        destino = 'm'
      }

      if( this.numeroTwilio == 'whatsapp:+5215545703336' ){
        conversaciones = [...(this.getConversacionesC || [])]
        destino = 'c'
      }

      if( this.numeroTwilio == 'whatsapp:+5213316971156' ){
        conversaciones = [...(this.getConversacionesG || [])]
        destino = 'g'
      }

      if( this.numeroTwilio == 'whatsapp:+5218123255321' ){
        conversaciones = [...(this.getConversacionesFast || [])]
        destino = 'fast'
      }

      if( this.numeroTwilio == 'whatsapp:+5215540435043' || this.numeroTwilio == 'whatsapp:+5215534952943' ){
        conversaciones = [...(this.getConversacionesAgente || [])]
        destino = 'agente'
      }

      if( this.numeroTwilio == 'whatsapp:+5218124384082'){
        conversaciones = [...(this.getConversacionesCRM || [])]
        destino = 'crm'
      }

      if( this.numeroTwilio == 'whatsapp:+5218124387901'){
        conversaciones = [...(this.getConversacionesCRMFast || [])]
        destino = 'crmfast'
      }

      if( this.numeroTwilio == 'whatsapp:+5215531108468'){
        conversaciones = [...(this.getConversacionesO || [])]
        destino = 'o'
      }

      if (!conversaciones.length && this.getConversacionesFast && this.getConversacionesFast.length) {
        conversaciones = [...this.getConversacionesFast]
        destino = 'fast'
      }

      const texto = payload && payload.mensaje != null ? payload.mensaje : this.message
      let fecha = payload && payload.fecha_ultimo_mensaje
      try {
        const { formatFechaMexicoFront } = require('@/utils/twilioFechaMexico')
        fecha = formatFechaMexicoFront(fecha || Date.now())
      } catch (_) {
        if (!fecha) {
          const d = new Date()
          const p = (n) => String(n).padStart(2, '0')
          fecha = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
        }
      }

      const existeUsuario = conversaciones.find( el => el.usuario == this.chat.usuario )

      if( existeUsuario ){
        for( const i in conversaciones ){
          if( conversaciones[i].usuario == this.chat.usuario ){
            if (texto != null && texto !== '') conversaciones[i].mensaje = texto
            conversaciones[i].sinleer = 0
            conversaciones[i].mio = 1
            conversaciones[i].reasignado = 0
            conversaciones[i].fecha_ultimo_mensaje = fecha
          }
        }
      }

      this.$set(this.chat, 'reasignado', 0)
      this.$set(this.chat, 'sinleer', 0)
      this.$set(this.chat, 'mio', 1)
      if (texto != null && texto !== '') this.$set(this.chat, 'mensaje', texto)

      if( destino === 'm' ) this.guardarConversacionesM( conversaciones )
      if( destino === 'c' ) this.guardarConversacionesC( conversaciones )
      if( destino === 'g' ) this.guardarConversacionesG( conversaciones )
      if( destino === 'fast' ) this.guardarConversacionesFast( conversaciones )
      if( destino === 'agente' ) this.guardarConversacionesAgente( conversaciones )
      if( destino === 'crm' ) this.guardarConversacionesCRM( conversaciones )
      if( destino === 'crmfast' ) this.guardarConversacionesCRMFast( conversaciones )
      if( destino === 'o' ) this.guardarConversacionesOnline( conversaciones )
    },

    cambiarCategoria( etiqueta ){
      if (!this.chat) return

      const idEtiqueta = Number(etiqueta)
      if (!idEtiqueta) {
        this.validarError('Etiqueta no válida')
        return
      }

      const usuarioErp = this.getdatosUsuarioERPERP || {}
      const usuario_cambio = {
        usuario_erp: usuarioErp.iderp || 0,
        trabajador_id: usuarioErp.id_trabajador || 0,
        usuario: usuarioErp.nombre_completo || '',
      }

      let twilioLinea = this.chat.numeroTwilio || this.chat.twilio || this.numeroTwilio || ''
      if (!twilioLinea && this.twiliosByCities && this.chat.city) {
        twilioLinea = this.twiliosByCities[this.chat.city] || ''
      }
      if (!twilioLinea) {
        this.validarError('No se identificó la línea de WhatsApp para guardar la etiqueta')
        return
      }

      // El id numérico largo es teléfono, no idusuarios_wpp. Mandar el usuario de WhatsApp.
      let usuarioWpp = this.chat.usuario != null ? String(this.chat.usuario).trim() : ''
      const idWpp = this.chat.idusuarios_wpp != null ? String(this.chat.idusuarios_wpp).trim() : ''
      const idEsTelefono = /^\d+$/.test(idWpp) && idWpp.length >= 10
      if (usuarioWpp.indexOf('whatsapp:') !== 0 && idWpp && !idEsTelefono) {
        usuarioWpp = idWpp
      }
      if (!usuarioWpp) {
        this.validarError('No se identificó el prospecto para guardar la etiqueta')
        return
      }

      const payload = {
        twilio: twilioLinea,
        usuario: usuarioWpp,
        etiqueta: idEtiqueta,
        usuario_cambio,
      }

      const meta = (this.etiquetas2 || this.etiquetas || []).find(e => Number(e.idetiquetas) === idEtiqueta) || {}
      const prevId = this.chat.idetiquetas
      const prevColor = this.chat.color
      this.aplicarEtiquetaEnFront(idEtiqueta, meta.color || null)

      return this.$http.post('twilio.etiqueta', payload ).then(()=>{
        this.cargar = false
      }).catch( error =>{
        this.aplicarEtiquetaEnFront(prevId, prevColor)
        let msg = 'No se pudo guardar la etiqueta'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      }).finally( () => { this.cargar = false })

    },

    /** Mismo prospecto aunque el usuario venga como +52 o +521 */
    chatCoincideEtiqueta (chat, usuario) {
      if (!chat) return false
      if (usuario && chat.usuario === usuario) return true
      const tel = String(usuario || '').replace(/\D/g, '').slice(-10)
      if (tel.length !== 10) return false
      const otro = String(chat.usuario || '').replace(/\D/g, '').slice(-10)
      return otro === tel
    },

    /** Pinta la etiqueta en el chat abierto y en la lista, sin reiniciar la vista */
    aplicarEtiquetaEnFront (idetiquetas, color) {
      if (!this.chat) return

      const idNum = idetiquetas == null || idetiquetas === '' ? null : Number(idetiquetas)
      const idFinal = idNum != null && !isNaN(idNum) ? idNum : idetiquetas
      const colorFinal = color || null
      this.$set(this.chat, 'idetiquetas', idFinal)
      this.$set(this.chat, 'color', colorFinal)

      const usuario = this.chat.usuario
      const patchLista = (lista) => {
        if (!Array.isArray(lista) || !lista.length) return lista
        let cambio = false
        const next = lista.map((c) => {
          if (!this.chatCoincideEtiqueta(c, usuario)) return c
          cambio = true
          return Object.assign({}, c, { idetiquetas: idFinal, color: colorFinal })
        })
        return cambio ? next : lista
      }

      const guardarSiCambio = (getter, action) => {
        if (typeof this[action] !== 'function' || !Array.isArray(this[getter])) return
        const next = patchLista(this[getter])
        if (next !== this[getter]) this[action](next)
      }

      if (Array.isArray(this.allChats) && this.allChats.length) {
        this.allChats = patchLista(this.allChats)
      }
      if (Array.isArray(this.conversaciones) && this.conversaciones.length) {
        this.conversaciones = patchLista(this.conversaciones)
      }

      guardarSiCambio('getConversacionesUnif', 'guardarConversacionesUnif')
      if (this.numeroTwilio == 'whatsapp:+5218123255321') {
        guardarSiCambio('getConversacionesFast', 'guardarConversacionesFast')
      }
      if (this.numeroTwilio == 'whatsapp:+5218187047279') {
        guardarSiCambio('getConversacionesM', 'guardarConversacionesM')
      }
      if (this.numeroTwilio == 'whatsapp:+5215545703336') {
        guardarSiCambio('getConversacionesC', 'guardarConversacionesC')
      }
      if (this.numeroTwilio == 'whatsapp:+5213316971156') {
        guardarSiCambio('getConversacionesG', 'guardarConversacionesG')
      }

      if (typeof this.conteoEtiquetas === 'function') {
        const base = (this.getConversacionesUnif && this.getConversacionesUnif.length)
          ? this.getConversacionesUnif
          : (this.getConversacionesFast && this.getConversacionesFast.length)
            ? this.getConversacionesFast
            : (this.allChats || this.conversaciones || [])
        this.conteoEtiquetas(base)
      }
    },

    cambiarCategoriaInscrito( etiqueta ){

      const {iderp, id_trabajador, nombre_completo} = this.getdatosUsuarioERPERP
      const usuario_cambio = {usuario_erp: iderp, trabajador_id: id_trabajador, usuario: nombre_completo} 
      const payload = {
        id_alumno     : this.chat.id_alumno,
        etiqueta,
        usuario_cambio
      }

      const meta = (this.etiquetas_inscritos || []).find(e => e.idetiquetas_inscritos == etiqueta || e.idetiquetas == etiqueta) || {}
      if (this.chat) {
        this.$set(this.chat, 'idetiquetas_inscritos', etiqueta)
        this.$set(this.chat, 'color_inscritos', meta.color || null)
      }

      return this.$http.post('twilio.etiqueta.alumno', payload ).then(()=>{
        this.cargar = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })

    },

    // obtener las vendedoras
    getVendedoras() {
      // this.cargar = true
      this.vendedoras_plantel  = []
      return this.$http.get('vendedoras.list').then((response) => {
        // Llenamos la etapa incial

        const unique = Array.from(
          new Map(response.data.map(item => [item.iderp, item])).values()
        );

        unique.sort((a, b) => a.nombre.localeCompare(b.nombre));

        this.vendedoras_plantel = unique.filter(el=> { return el.escuela == this.escuela})
        // this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      })//.finally( () => { this.cargar = false })
    },


  },


}